import { CsvHeader } from 'types'

export const csvTemplateHeaders: CsvHeader[] = [
  { label: 'SiteId', key: 'siteId' },
  { label: 'Regions', key: 'Regions' },
  { label: 'HSP_ImplementationLevel', key: 'HSP_ImplementationLevel' },
  { label: 'HSP_ImplementationType', key: 'HSP_ImplementationType' },
  { label: 'HSP_IsLaunched', key: 'HSP_IsLaunched' },
  { label: 'HSP_StudentActivities', key: 'HSP_StudentActivities' },
  {
    label: 'MSP_BullyingHarassmentUnitEnabled',
    key: 'MSP_BullyingHarassmentUnitEnabled',
  },
  { label: 'MSP_TIAssessment', key: 'MSP_TIAssessment' },
  { label: 'K5P_TIAssessment', key: 'K5P_TIAssessment' },
  { label: 'K5P_ProgramIsEnabledForSku', key: 'K5P_ProgramIsEnabledForSku' },
]
